import React, { useContext, useState } from "react";
import RegImg from "../assets/requester.webp";
import RegImgIos from "../assets/requester.jpg";
import DonorImg from "../assets/register.webp";
import DonorImgIos from "../assets/register.jpg";
import "../CSS/register.css";
import AuthContext from "../../context/AuthContext";
import { Redirect } from "react-router-dom";
import RegisterDonorForm from "./RegisterDonorForm";
import RegisterRequesterForm from "./RegisterRequesterForm";

export default function Register() {
  const [userType, setUserType] = useState(""); // user type: "donor" or "requester".
  const [requesterid, setRequesterId] = useState("requester-image-container"); // This state is used for setting animations
  const [donorid, setDonorId] = useState("donor-image-container"); // This state is used for setting animations
  const [formid, setFormId] = useState("sliding-bottom-before"); // This state is used for setting animations
  const [donorFormLeave, setDonorFormLeave] = useState(""); // This state is used for setting animations
  const [requesterFormLeave, setRequesterFormLeave] = useState(""); // This state is used for setting animations
  const handleRequesterClick = () => {
    setRequesterId("requester-image-container-color");
    setDonorId("donor-image-container-sliding");
    setTimeout(() => {
      setUserType("requester");
    }, 1000);
    setTimeout(() => {
      setFormId("sliding-bottom-after");
    }, 0);
    setDonorFormLeave("donor-leave");
    setRequesterFormLeave("");
  };

  const handleDonorClick = () => {
    setDonorId("donor-image-container-color");
    setRequesterId("requester-image-container-sliding");
    setTimeout(() => {
      setUserType("donor");
    }, 1000);
    setTimeout(() => {
      setFormId("sliding-bottom-after");
    }, 0);
    setDonorFormLeave("");
    setRequesterFormLeave("requester-leave");
  };

  const { user } = useContext(AuthContext);
  // if user already logged in, redirect to home
  if (user) {
    return <Redirect to="/" />;
  }

  return (
    <div>
      {userType === "" ? (
        <div className="main-container">
          <div className="container-fluid" id={requesterid} onClick={handleRequesterClick}>
            <h3 className="image-label">Register as an</h3>
            <h3 className="image-label">Organization</h3>
            <p className="image-label-sub">Make multiple blood requests.</p>
            <picture>
              <source srcSet={RegImg} type="image/webp" />
              <source srcSet={RegImgIos} type="image/png" />
              <img src={RegImgIos} alt="Background" className="img-fluid" id="requester-image" />
            </picture>
          </div>
          <div className="container-fluid" id={donorid} onClick={handleDonorClick}>
            <h3 className="image-label">Register as a</h3>
            <h3 className="image-label">Donor</h3>
            <p className="image-label-sub">
              Recieve blood requests and donate blood.
            </p>
            <picture>
              <source srcSet={DonorImg} type="image/webp" />
              <source srcSet={DonorImgIos} type="image/png" />
              <img src={DonorImgIos} alt="Background" className="img-fluid" id="donor-image" />
            </picture>
          </div>
        </div>
      ) : userType === "donor" ? (
        <div className="main-container">
          <div className={formid}>
            <RegisterDonorForm
              id={donorFormLeave}
              buttonClick={handleRequesterClick}
            />
          </div>
          <div className="container-fluid" id={donorid}>
            <h3 className="image-label">Register as a</h3>
            <h3 className="image-label">Donor</h3>
            <p className="image-label-sub">
              Recieve blood requests and donate blood.
            </p>
            <picture>
              <source srcSet={DonorImg} type="image/webp" />
              <source srcSet={DonorImgIos} type="image/png" />
              <img src={DonorImgIos} alt="Background" className="img-fluid" id="donor-image" onClick={handleDonorClick}/>
            </picture>
          </div>
        </div>
      ) : (
        <div className="main-container">
          <div className="container-fluid" id={requesterid}>
            <h3 className="image-label">Register as an</h3>
            <h3 className="image-label">Organization</h3>
            <p className="image-label-sub">Make multiple blood requests.</p>
            <picture>
              <source srcSet={RegImg} type="image/webp" />
              <source srcSet={RegImgIos} type="image/png" />
              <img src={RegImgIos} alt="Background" className="img-fluid" id="requester-image" onClick={handleRequesterClick}/>
            </picture>
          </div>
          <div className={formid}>
            <RegisterRequesterForm
              id={requesterFormLeave}
              buttonClick={handleDonorClick}
            />
          </div>
        </div>
      )}
    </div>
  );
}
